<template>
    <div class="conditionpaymentreceipt">
        <PageTitle
            icon="fa fa-clone"
            main="Registro"
            sub="Condição de Pagamento/Recebimento"
        />

        <b-form
            v-show="mode === 'save' || mode === 'remove' || mode === 'read'"
        >
            <input
                id="conditionpaymentreceipt-id"
                type="hidden"
                v-model="conditionpaymentreceipt.id"
            />
            <b-row>
                <b-col md="6" sm="12">
                    <b-form-group
                        label="Nome:"
                        label-for="conditionpaymentreceipt-name_condition_payment_receipt"
                    >
                        <b-form-input
                            id="conditionpaymentreceipt-name_condition_payment_receipt"
                            type="text"
                            v-model="
                                conditionpaymentreceipt.name_condition_payment_receipt
                            "
                            size="sm"
                            ref="focusadd"
                            :readonly="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            placeholder="Nome..."
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input
                                class="form-check-input"
                                v-model="conditionpaymentreceipt.payment"
                                true-value="1"
                                false-value="0"
                                type="checkbox"
                                id="conditionpaymentreceipt-payment"
                                :disabled="
                                    mode === 'remove' ||
                                        mode === 'read' ||
                                        mode === 'insert'
                                "
                            />
                            <label
                                class="form-check-label"
                                for="conditionpaymentreceipt-payment"
                            >
                                Pagamento?
                            </label>
                        </div>
                    </div>
                </b-col>
                <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input
                                class="form-check-input"
                                v-model="conditionpaymentreceipt.receipt"
                                true-value="1"
                                false-value="0"
                                type="checkbox"
                                id="conditionpaymentreceipt-receipt"
                                :disabled="
                                    mode === 'remove' ||
                                        mode === 'read' ||
                                        mode === 'insert'
                                "
                            />
                            <label
                                class="form-check-label"
                                for="conditionpaymentreceipt-receipt"
                            >
                                Recebimento?
                            </label>
                        </div>
                    </div>
                </b-col>
                <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input
                                class="form-check-input"
                                v-model="conditionpaymentreceipt.blocked"
                                true-value="1"
                                false-value="0"
                                type="checkbox"
                                id="conditionpaymentreceipt-blocked"
                                :disabled="
                                    mode === 'remove' ||
                                        mode === 'read' ||
                                        mode === 'insert'
                                "
                            />
                            <label
                                class="form-check-label"
                                for="conditionpaymentreceipt-blocked"
                            >
                                Bloqueado?
                            </label>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-form>

        <hr v-show="mode === 'save'" />
        <b-row>
            <b-col xs="12">
                <b-button
                    size="sm"
                    variant="dark"
                    class="mt-2  mb-2 fa fa-plus"
                    v-show="mode !== 'save' && mode !== 'remove'"
                    @click="alterModo"
                >
                </b-button>
                <b-button
                    size="sm"
                    variant="dark"
                    class="mt-2 mb-2 mb-2 ml-2 fa fa-save"
                    v-if="mode === 'save'"
                    @click="save"
                >
                </b-button>
                <b-button
                    size="sm"
                    variant="dark"
                    class="mt-2 mb-2 ml-2 fa fa-trash"
                    v-if="mode === 'remove'"
                    @click="remove"
                >
                </b-button>
                <b-button
                    size="sm"
                    btn-sm
                    variant="dark"
                    class="mt-2 mb-2 ml-2 fa fa-reply"
                    v-if="
                        mode === 'remove' || mode === 'save' || mode === 'read'
                    "
                    @click="reset"
                >
                </b-button>
                <b-button
                    size="sm"
                    class="mt-2 mb-2 ml-2 fa"
                    :class="icon"
                    @click="
                        ;[
                            loadConditionPaymentReceipts(),
                            toggleBusy(),
                            (showTable = !showTable)
                        ]
                    "
                    variant="dark"
                >
                </b-button>
            </b-col>
        </b-row>
        <br />
        <div class="col-sm-6">
            <div class="form-group">
                <input
                    type="text"
                    v-on:keyup.alt.enter="alterModo"
                    v-on:keyup.alt.73="focusAdd"
                    size="sm"
                    icon="search"
                    title="Atalho para Inserir (ALT+ENTER => ALT+I)"
                    v-model="search"
                    ref="inputsearch"
                    v-show="mode !== 'save' && mode !== 'remove'"
                    placeholder="Informe a descrição"
                    class="form-control"
                />
            </div>
        </div>

        <b-row>
            <b-col md="8" sm="12">
                <transition name="slide" type="animation" appear>
                    <b-table
                        :busy="isBusy"
                        class="table-responsive"
                        v-show="showTable"
                        hover
                        key="slide"
                        head-variant="light"
                        :per-page="perPage"
                        :current-page="currentPage"
                        :items="filteredList"
                        :fields="fields"
                    >
                        <template v-slot:table-busy>
                            <div class="text-center text-info my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Carregando...</strong>
                            </div>
                        </template>
                        <template v-slot:cell(actions)="data">
                            <b-button
                                title="Detalhe do registro"
                                size="sm"
                                variant="light"
                                @click="
                                    loadConditionPaymentReceipt(
                                        data.item,
                                        'read'
                                    )
                                "
                                class="mr-2 mt-2"
                            >
                                <i class="fa fa-drivers-license-o"></i>
                            </b-button>
                            <b-button
                                title="Editar registro"
                                size="sm"
                                variant="light"
                                @click="loadConditionPaymentReceipt(data.item)"
                                class="mr-2 mt-2"
                            >
                                <i class="fa fa-pencil"></i>
                            </b-button>
                            <b-button
                                title="Excluir registro"
                                size="sm"
                                variant="light"
                                @click="
                                    loadConditionPaymentReceipt(
                                        data.item,
                                        'remove'
                                    )
                                "
                                class="mr-2 mt-2"
                            >
                                <i class="fa fa-trash"></i>
                            </b-button>
                            <b-button
                                v-b-modal.modalDay
                                title="Adicionar Prazo da Condição"
                                size="sm"
                                variant="light"
                                @click="actionNewDay(data.item)"
                                class="mr-2 mt-2"
                            >
                                <i class="fa fa-plus"></i>
                            </b-button>
                            <b-button
                                title="Listar sequência de dias"
                                size="sm"
                                variant="light"
                                @click="setDay(data.item)"
                                class="mr-2 mt-2"
                            >
                                <i class="fa fa-tasks"></i>
                            </b-button>
                        </template>
                    </b-table>
                </transition>
                <transition name="slide" type="animation" appear>
                    <b-pagination
                        v-show="showTable"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        size="sm"
                        aria-controls="my-table"
                    ></b-pagination>
                </transition>
            </b-col>
            <b-col md="4" sm="12">
                <transition name="slide" type="animation" appear>
                    <b-table
                        class="table-responsive"
                        v-show="showTableDay"
                        hover
                        head-variant="light"
                        key="slide"
                        :items="conditionpaymentreceiptdays"
                        :fields="fieldsDay"
                    >
                        <template v-slot:cell(actions)="data">
                            <b-button
                                v-b-modal.modalDay
                                title="Editar registro"
                                size="sm"
                                variant="light"
                                @click="
                                    loadConditionPaymentReceiptDay(data.item)
                                "
                                class="mr-2 mt-2"
                            >
                                <i class="fa fa-pencil"></i>
                            </b-button>
                            <b-button
                                size="sm"
                                variant="light"
                                @click="
                                    ;[
                                        loadConditionPaymentReceiptDay(
                                            data.item
                                        ),
                                        (modeDay = 'remove')
                                    ]
                                "
                                class="mr-2 mt-2"
                                v-if="modeDay === 'insert'"
                            >
                                <i class="fa fa-trash"></i>
                            </b-button>
                            <b-button
                                size="sm"
                                variant="light"
                                @click="
                                    ;[
                                        removeDay(data.item),
                                        (modeDay = 'insert')
                                    ]
                                "
                                class="mr-2 mt-2"
                                v-if="modeDay === 'remove'"
                            >
                                <i class="fa fa-check"></i>
                            </b-button>
                            <b-button
                                size="sm"
                                variant="light"
                                @click="modeDay = 'insert'"
                                class="mr-2 mt-2"
                                v-if="modeDay === 'remove'"
                            >
                                <i class="fa fa-times"></i>
                            </b-button>
                            <span class="mr-2 mt-2" v-if="modeDay === 'remove'">
                                Deseja Excluir o registro?</span
                            >
                        </template>
                    </b-table>
                </transition>
            </b-col>
        </b-row>

        <b-modal
            id="modalDay"
            ref="modal"
            title-tag="h6"
            title="Prazo em Dias"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveDay"
        >
            <b-form>
                <b-row>
                    <b-col md="2" sm="12">
                        <b-form-group
                            label="Ordem:"
                            label-for="conditionpaymentreceiptday-day_id"
                        >
                            <b-form-input
                                id="conditionpaymentreceiptday-day_id"
                                v-model="conditionpaymentreceiptday.day_id"
                                type="number"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="2" sm="12">
                        <b-form-group
                            label="Prazo:"
                            label-for="conditionpaymentreceiptday-day"
                        >
                            <b-form-input
                                id="conditionpaymentreceiptday-day"
                                v-model="conditionpaymentreceiptday.day"
                                type="number"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'

export default {
    name: 'ConditionPaymentReceipt',
    components: { PageTitle },
    data: function() {
        return {
            mode: 'insert',
            modeDay: 'insert',
            search: '',
            conditionpaymentreceipt: {},
            conditionpaymentreceipts: [],
            conditionpaymentreceiptday: {},
            conditionpaymentreceiptdays: [],
            showTable: false,
            showTableDay: false,
            perPage: 5,
            currentPage: 1,
            isBusy: false,
            headerBgVariant: 'dark',
            headerTextVariant: 'light',
            bodyBgVariant: 'light',
            bodyTextVariant: 'dark',
            footerBgVariant: 'warning',
            footerTextVariant: 'dark',
            fields: [
                {
                    key: 'name_condition_payment_receipt',
                    label: 'Descrição',
                    sortable: true
                },
                {
                    key: 'payment',
                    label: 'Pagamento',
                    sortable: false,
                    formatter: value => (value ? 'Sim' : 'Não')
                },
                {
                    key: 'receipt',
                    label: 'Recebimento',
                    sortable: false,
                    formatter: value => (value ? 'Sim' : 'Não')
                },
                { key: 'actions', label: 'Ações', variant: 'light' }
            ],
            fieldsDay: [
                { key: 'day_id', label: 'Ordem', sortable: true },
                { key: 'day', label: 'Prazo em Dias', sortable: false },
                { key: 'actions', label: 'Ações', variant: 'light' }
            ]
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        filteredList() {
            return this.conditionpaymentreceipts.filter(
                conditionpaymentreceipt => {
                    return conditionpaymentreceipt.name_condition_payment_receipt
                        .toLowerCase()
                        .includes(this.search.toLowerCase())
                }
            )
        },
        icon() {
            return this.showTable ? 'fa-retweet' : 'fa-search'
        },
        rows() {
            return this.conditionpaymentreceipts.length
        }
    },
    methods: {
        async loadConditionPaymentReceipts() {
            const url = `${baseApiUrl}/conditionpaymentreceipts`
            await axios.get(url).then(res => {
                this.conditionpaymentreceipts = res.data
                this.isBusy = false
            })
        },
        toggleBusy() {
            this.isBusy = !this.isBusy
        },
        async loadConditionPaymentReceiptDays() {
            const url = `${baseApiUrl}/conditionpaymentreceiptdays/${this.conditionpaymentreceipt.id}`
            await axios.get(url).then(res => {
                this.conditionpaymentreceiptdays = res.data
            })
        },
        async reset() {
            this.mode = 'insert'
            await this.loadConditionPaymentReceipts()
            this.conditionpaymentreceiptdays = []
        },
        alterModo() {
            this.mode = 'save'
            this.conditionpaymentreceipt = {}
        },
        async save() {
            const method = this.conditionpaymentreceipt.id ? 'put' : 'post'
            const id = this.conditionpaymentreceipt.id
                ? `/${this.conditionpaymentreceipt.id}`
                : ''
            this.conditionpaymentreceipt.user_id = this.user.id
            await axios[method](
                `${baseApiUrl}/conditionpaymentreceipts${id}`,
                this.conditionpaymentreceipt
            )
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
        async saveDay() {
            const method = this.conditionpaymentreceiptday.id ? 'put' : 'post'
            const id = this.conditionpaymentreceiptday.id
                ? `/${this.conditionpaymentreceiptday.id}`
                : ''

            this.conditionpaymentreceiptday.user_id = this.user.id
            this.conditionpaymentreceiptday.condition_payment_receipt_id = this.conditionpaymentreceipt.id
            await axios[method](
                `${baseApiUrl}/conditionpaymentreceiptdays${id}`,
                this.conditionpaymentreceiptday
            )
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    await this.loadConditionPaymentReceiptDays()
                })
                .catch(showError)
        },
        async remove() {
            const id = this.conditionpaymentreceipt.id
            await axios
                .delete(`${baseApiUrl}/conditionpaymentreceipts/${id}`)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
        async removeDay() {
            const id = this.conditionpaymentreceiptday.id
            await axios
                .delete(`${baseApiUrl}/conditionpaymentreceiptdays/${id}`)
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    await this.loadConditionPaymentReceiptDays()
                })
                .catch(showError)
        },
        loadConditionPaymentReceipt(conditionpaymentreceipt, mode = 'save') {
            this.mode = mode
            this.conditionpaymentreceipt = { ...conditionpaymentreceipt }
        },
        loadConditionPaymentReceiptDay(conditionpaymentreceiptday) {
            this.conditionpaymentreceiptday = { ...conditionpaymentreceiptday }
        },
        async actionNewDay(conditionpaymentreceipt) {
            this.conditionpaymentreceipt = { ...conditionpaymentreceipt }
            this.conditionpaymentreceiptday = {}
            await this.loadConditionPaymentReceiptDays()
            this.showTableDay = true
        },
        async setDay(conditionpaymentreceipt) {
            this.conditionpaymentreceipt = { ...conditionpaymentreceipt }
            this.conditionpaymentreceiptday = {}
            await this.loadConditionPaymentReceiptDays()
            this.showTableDay = true
        },
        focusAdd() {
            this.$refs.focusadd.focus()
        },
        focusSearch() {
            this.$refs.inputsearch.focus()
        }
    },
    async mounted() {
        await this.loadConditionPaymentReceipts()
        this.showTable = true
    }
}
</script>

<style>
.conditionpaymentreceipt {
    font-size: 0.7rem;
}

.conditionpaymentreceipt input,
label,
form {
    font-size: 0.7rem;
}
.conditionpaymentreceipt button {
    font-size: 0.7rem;
}

.conditionpaymentreceipt select {
    font-size: 0.7rem;
}

.conditionpaymentreceipt table {
    font-size: 0.7rem;
}

#modalDay {
    font-size: 0.7rem;
}

#modalDay input {
    font-size: 0.7rem;
}

#modalDay button {
    font-size: 0.7rem;
}

@keyframes slide-in {
    from {
        transform: translateY(40px);
    }
    to {
        transform: translateY(0);
    }
}

@keyframes slide-out {
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(40px);
    }
}

.slide-enter-active {
    animation: slide-in 1s ease;
    transition: opacity 1s;
}

.slide-leave-active {
    animation: slide-out 1s ease;
    transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
    opacity: 0;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s;
}
</style>
